import React, { useState, useContext, useEffect } from 'react';
import { Radio, Col, Row } from 'antd';
import Select from 'react-select';
import find from 'lodash/find';
import { DeclaredComponent } from '../../DynamicComponent';
import { PaymentDetailsContext } from './PaymentDetailsForm';
import { PaymentInfoContext } from '../../../context/PaymentInfoProvider';
import { FormContext } from '../../metadata/MDForm';
import { ModelContext } from '../../metadata/ModelSource';
import { getPaymentSources } from '../../../api/buyAPI';
import { navigateToHome } from '../../../navigation/navigationHistory';

const RadioButtons = ({ buttons }) => {
  return buttons.map((button, index) => {
    const buttonWidth = 100 / buttons.length;
    return (
      <Radio.Button
        style={{ width: `${buttonWidth}%` }}
        key={index}
        value={button.type}
        className="secondary-button"
      >
        <div style={{ textAlign: 'center' }}>{button.label}</div>
      </Radio.Button>
    );
  });
};

const AccountSelect = ({ id, component, options }) => {
  let { setValueByAttr, getValueByAttr } = useContext(FormContext);
  let typeSelection = options.filter(it=> it.value === getValueByAttr(id));
    typeSelection = typeSelection.length ? {value: typeSelection[0].value, label: typeSelection[0].name}: null;

  const typeChange = (selection) => {
    if (selection.value === 'Checking' || selection.value === 'Savings') {
      setValueByAttr('BankAccountType',selection.value);
    }
    if (selection.value === 'PPD' || selection.value === 'CCD') {
      setValueByAttr('AccountType',selection.value);
    }
  };

  const updatedOptions = options.map((option) => {
    return {
      value: option.value,
      label: option.name,
    };
  });

  return (
    <Select
        id={id}
      aria-label="Select"
      styles={customStyles}
      title="Select"
      openMenuOnFocus
      placeholder={null}
      options={updatedOptions}
      value={typeSelection}
      onChange={typeChange}
      components={{
        IndicatorSeparator: () => null,
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        zIndex: 3,
        colors: {
          ...theme.colors,
          primary25: 'rgb(0, 115, 157, 0.1)',
          primary: 'rgba(0, 115, 157, 0.5)',
          neutral30: 'rgba(0, 115, 157, 0.5)',
        },
      })}
    />
  );
};

export const SelectedMethod = ( {content}) => {

  const { getValueByAttr } = useContext(FormContext);
  const selection = getValueByAttr('PaymentMethod');
  const selectPaymentType = getValueByAttr('ExistCardId');
  const selectedGroup = find(content, selection);
  const { accountTypes, bankAccountTypes } = useContext(PaymentDetailsContext);

  if(!selection) return null;
  if (selectPaymentType !== 'NewCard') return null;

  if(selection === 'ACH'){
    const types = [accountTypes, bankAccountTypes];
    const selectedContent  = selectedGroup[selection]["content"];
    return (
      <div style={{ marginTop: '30px' }}>
        <p>Bank Account Type</p>
        <div>
          <Row gutter={8} style={{ marginBottom: '30px' }}>
            <Col span={16}>
              <div style={{ display: 'flex' }}>
                {types.map((type, index) => {
                  return (
                    <div key={index} style={{ flex: 1 }}>
                      <AccountSelect
                          id={
                            index === 0
                                ? 'AccountType'
                                : 'BankAccountType'
                          }
                          key={index}
                          options={type}
                      />
                    </div>
                  );
                })}
              </div>
            </Col>
          </Row>
          {selectedContent.map((component, index) => {
            if (
              component.Field &&
              component.Field.attr &&
              (component.Field.attr === 'BankAccountType' ||
                  component.Field.attr === 'AccountType')
            ) {
              return null;
            }
            return (
              <DeclaredComponent
                  aria-label="Input"
                  declaration={component}
                  key={index}
              />
            );
          })}
        </div>
      </div>
    );
  } else if (selection === 'CC'){
    const selectedContent = selectedGroup[selection]["content"];
    const creditCardContent = selectedContent.map((component, index) => (
      <DeclaredComponent
        aria-label="Input"
        declaration={component}
        key={index}
      />
      ));
    return creditCardContent;
  } else {
    return null;
  }
};

export const PaymentMethodSelect = ({buttons, onChange}) => {
  return (
      <div>
        <Radio.Group
          // defaultValue={'CC'}
          onChange={onChange}
          buttonStyle="solid"
        >
          <RadioButtons buttons={buttons}/>
        </Radio.Group>
      </div>
  )
};

export const PaymentType = () => {
  const { getValueByAttr, setValueByAttr,setValue, touch } = useContext(FormContext);
  const { setExistCardId } = useContext(PaymentInfoContext);
  const existCardId = getValueByAttr('ExistCardId');

  let [ typeButtons, setTypeButtons ] = useState([
    {
      type: 'NewCard',
      label: 'Add New Payment Type',
    }]);
  const applicationModel = useContext(ModelContext);

  const convertPaymentSources = (data)=>{
    if (!Array.isArray(data)) return;
    const buttons = [];
    data.forEach((d,i)=>{
      buttons.push({
        paymentResource:{...d},
        type: 'ExistCard'+i,
        label: d.methodCd === 'ACH' ? 'ACH Bank ' + d.achBankAccountNumber : `CC ${d.creditCardTypeCd} ${d.creditCardNumber}`,
      })
    })
    buttons.push({
      type: 'NewCard',
      label: 'Add New Payment Type',
    });
    setTypeButtons(buttons);
  }

  useEffect(()=>{
    getPaymentSources(applicationModel.data.systemId).then(
        (res) => {
          convertPaymentSources(res.data.electronicPaymentSource);
        }
    ).catch(err => {
      const status = (err.response ? err.response.status : 500);
      if (status === 403) navigateToHome( );  // Permission denied suggests application-session ended
      throw (err);
    });
  },[]);

  const onPaymentTypeChange = (e)=> {
    const type = e.target.value;
    const existCard = typeButtons.find(v => v.type === type);
    if (type === "NewCard") {
      const path = 'basicPolicy.electronicPaymentSource';
      const electronicPaymentSource = applicationModel.getValue(path)
      let ePaymentSource = {...electronicPaymentSource,
        achBankAccountNumber:''};
      const selection = getValueByAttr('PaymentMethod');
      if (selection === 'ACH') {
        ePaymentSource = {...ePaymentSource,paymentMethod:''}
      }
      setValue('basicPolicy.electronicPaymentSource', {...ePaymentSource});
      touch('CreditCardNumber',false);
    }else {
      const paymentResource = getValueByAttr('paymentResource');
      setValue('basicPolicy.electronicPaymentSource', {...paymentResource,...existCard.paymentResource});
    }
    setValueByAttr('ExistCardId', existCard.type);
    setExistCardId(existCard.type);
  }

  return (
    <div>
      <Radio.Group
        onChange={onPaymentTypeChange}
        buttonStyle="solid"
        value={existCardId}
      >
        <Radios buttons={typeButtons}/>
      </Radio.Group>
    </div>
  )
};

const Radios = ({ buttons }) => {
  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
  };
  return buttons.map((button, index) => {
    return (
      <Radio style={radioStyle} key={index} value={button.type}>
        {button.label}
      </Radio>
    );
  })
};

const customStyles = {
  control: (base) => ({
    ...base,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};
